
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree80f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree80f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cj86l", function(module, exports) {

$parcel$export(module.exports, "modal", function () { return $8f38ba58a360384b$export$96e4b36520c26a2c; });

var $axHuj = parcelRequire("axHuj");

var $cHhba = parcelRequire("cHhba");
function $8f38ba58a360384b$export$96e4b36520c26a2c(title, body, footer) {
    let modalWindow = (0, $axHuj.modalTemplate)(title, body, footer);
    var div = document.createElement("div");
    div.classList.add("modal-autogen");
    div.classList.add("show");
    div.innerHTML = modalWindow.trim();
    document.body.appendChild(div);
    let modalCloser = new (0, $cHhba.BD)(".close-btn");
    let modal = new (0, $cHhba.BD)(".modal-autogen");
    modalCloser.onclick((target)=>{
        modal.remClass("show");
        modal.remove();
    });
}

});
parcelRegister("axHuj", function(module, exports) {

$parcel$export(module.exports, "modalTemplate", function () { return $d99deae7906ad3b0$export$dbb79f87ff4e57c4; });
function $d99deae7906ad3b0$export$dbb79f87ff4e57c4(title, body, footer) {
    //<div class="modal" id="target-modal-1">
    return `
        <div class="modal-container">
            <div class="modal-header">
                <span class="close-btn">&times;</span>
                ${title}
            </div>
            <div class="modal-content">
            ${body}
            </div>
            <div class="modal-footer">
                ${footer}
                <button class="close-btn modal-btn-close">Ok</button>
            </div>
        </div>
    `;
//</div>
}

});

parcelRegister("cHhba", function(module, exports) {

$parcel$export(module.exports, "BD", function () { return $08770d3ccccf1317$export$2672079d1ac1dedf; });
class $08770d3ccccf1317$export$2672079d1ac1dedf {
    get bd() {
        return this.bdomobj;
    }
    get html() {
        if (this.exist) return this.bdomobj.innerHTML;
        else return "";
    }
    set html(value) {
        if (this.exist) this.bdomobj.innerHTML = value;
    }
    animation(animation) {
        this.bdomobj.style.animation = animation;
    }
    hide() {
        this.bdomobj.style.display = "none";
    }
    show() {
        this.bdomobj.style.display = "block";
    }
    ishide() {
        if (this.bdomobj.style.display == "none") return true;
        return false;
    }
    isChecked() {
        return this.bdomobj.checked;
    }
    appendTo(domobjappend) {
        this.bdomobj.appendChild = domobjappend;
    }
    appendToTxtMode(txt) {
        let p = document.createTextNode(txt);
        this.bdomobj.appendChild(p);
    }
    appendChild(domobjappend) {
        this.bdomobj.appendChild(domobjappend);
    }
    countChild() {
        return this.bdomobj.childElementCount;
    }
    remove() {
        if (this.type == "id") this.bdomobj.remove();
        if (this.type == "class") for(let i = 0; i < this.bdomobj.length; i++)this.bdomobj[i].remove();
    }
    addClass(cssclass) {
        if (this.type == "id") this.bdomobj.classList.add(cssclass);
        if (this.type == "class") for(let i = 0; i < this.bdomobj.length; i++)this.bdomobj[i].classList.add(cssclass);
    }
    remClass(cssclass) {
        if (this.type == "id") this.bdomobj.classList.remove(cssclass);
        if (this.type == "class") for(let i = 0; i < this.bdomobj.length; i++)this.bdomobj[i].classList.remove(cssclass);
    }
    getAttribute(attr) {
        if (this.type == "id") return this.bdomobj.getAttribute(attr);
        if (this.type == "class") return this.bdomobj[0].getAttribute(attr);
    }
    get val() {
        if (this.exist) return this.bdomobj.value;
        else return "";
    }
    set val(value) {
        if (this.exist) this.bdomobj.value = value;
    }
    onclick(f) {
        if (this.type == "id") this.bdomobj.addEventListener("click", f);
        if (this.type == "class") for(let i = 0; i < this.bdomobj.length; i++)this.bdomobj[i].addEventListener("click", f);
    }
    onchange(f) {
        if (this.type == "id") this.bdomobj.addEventListener("change", f);
        if (this.type == "class") for(let i = 0; i < this.bdomobj.length; i++)this.bdomobj[i].addEventListener("change", f);
    }
    constructor(domobj){
        this.exist = false;
        this.type = "";
        if (domobj.charAt(0) == ".") {
            domobj = domobj.substring(1);
            this.type = "class";
            this.bdomobj = document.getElementsByClassName(domobj);
            if (this.bdomobj != null) this.exist = true;
            else console.log("Error: this class " + domobj + " not exist in dom");
        }
        if (domobj.charAt(0) == "#") {
            domobj = domobj.substring(1);
            this.type = "id";
            this.bdomobj = document.getElementById(domobj);
            if (this.bdomobj != null) this.exist = true;
            else console.log("Error: this id " + domobj + " not exist  in dom");
        }
        if (domobj.charAt(0) == "@") {
            domobj = domobj.substring(1);
            this.type = "name";
            this.bdomobj = document.querySelectorAll("select[name='" + domobj + "']");
            if (this.bdomobj != null) this.exist = true;
            else console.log("Error: this name " + domobj + " not exist  in dom");
        }
    }
}

});



var $cj86l = parcelRequire("cj86l");
/**
 * Modern Browser
 */ document.documentElement.className = "js";
var $c8ef241e33ac9d7d$var$supportsCssVars = function() {
    var _t_parentNode;
    var e, t = document.createElement("style");
    return t.innerHTML = "root: { --tmp-var: bold; }", document.head.appendChild(t), e = !!(window.CSS && window.CSS.supports && window.CSS.supports("font-weight", "var(--tmp-var)")), (_t_parentNode = t.parentNode) === null || _t_parentNode === void 0 ? void 0 : _t_parentNode.removeChild(t), e;
};
$c8ef241e33ac9d7d$var$supportsCssVars() || alert("Please view this site in a modern browser that supports CSS Variables.");
/**
 * Navbar
 */ const $c8ef241e33ac9d7d$var$hamburger = document.querySelector(".hamburger");
const $c8ef241e33ac9d7d$var$navMenu = document.querySelector(".nav-menu");
$c8ef241e33ac9d7d$var$hamburger === null || $c8ef241e33ac9d7d$var$hamburger === void 0 ? void 0 : $c8ef241e33ac9d7d$var$hamburger.addEventListener("click", $c8ef241e33ac9d7d$var$mobileMenu);
function $c8ef241e33ac9d7d$var$mobileMenu() {
    $c8ef241e33ac9d7d$var$hamburger === null || $c8ef241e33ac9d7d$var$hamburger === void 0 ? void 0 : $c8ef241e33ac9d7d$var$hamburger.classList.toggle("active");
    $c8ef241e33ac9d7d$var$navMenu === null || $c8ef241e33ac9d7d$var$navMenu === void 0 ? void 0 : $c8ef241e33ac9d7d$var$navMenu.classList.toggle("active");
}
const $c8ef241e33ac9d7d$var$navLink = document.querySelectorAll(".nav-link");
$c8ef241e33ac9d7d$var$navLink.forEach((n)=>n.addEventListener("click", $c8ef241e33ac9d7d$var$closeMenu));
function $c8ef241e33ac9d7d$var$closeMenu() {
    $c8ef241e33ac9d7d$var$hamburger === null || $c8ef241e33ac9d7d$var$hamburger === void 0 ? void 0 : $c8ef241e33ac9d7d$var$hamburger.classList.remove("active");
    $c8ef241e33ac9d7d$var$navMenu === null || $c8ef241e33ac9d7d$var$navMenu === void 0 ? void 0 : $c8ef241e33ac9d7d$var$navMenu.classList.remove("active");
}
const $c8ef241e33ac9d7d$var$url = window.location.href;
const $c8ef241e33ac9d7d$var$segments = $c8ef241e33ac9d7d$var$url.split("/");
const $c8ef241e33ac9d7d$var$lang = $c8ef241e33ac9d7d$var$segments[3];
const $c8ef241e33ac9d7d$var$today = new Date();
const $c8ef241e33ac9d7d$var$cutoffDate = new Date("2025-04-01");
if ($c8ef241e33ac9d7d$var$today < $c8ef241e33ac9d7d$var$cutoffDate) {
    if ($c8ef241e33ac9d7d$var$lang === "it") (0, $cj86l.modal)("Informazioni", "Riapertura 18 Aprile / Re-opening April 18th", "");
    else if ($c8ef241e33ac9d7d$var$lang === "en") (0, $cj86l.modal)("Information", "Riapertura 18 Aprile / Re-opening April 18th", "");
    else (0, $cj86l.modal)("Informazioni", "Riapertura 18 Aprile / Re-opening April 18th", "");
} /**
 * when scroll 
 */  /*

var dimension = 100;
var originaldimension = 100;
var maxdimension = 200;
var lastScrollTop = 0;
 window.addEventListener('scroll', function() {
    
    let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
  
    if (st > lastScrollTop){
      // downscroll code
      console.log('down');
      if(dimension<= maxdimension)
      dimension =Math.floor(dimension+(this.window.scrollY/100))
   } else {
      // upscroll code
      console.log('up');
      if(dimension> originaldimension)
      dimension =Math.floor(dimension-(this.window.scrollY/100))
   }

    
    
    console.log(dimension);

    let prenobg = document.getElementById('preno')
    if(prenobg != null){
        
    prenobg.style.backgroundSize = "200% 200%"
    }
});
var lastScrollTop = 0;
var dimension = 100;
var originaldimension = 100;
var maxdimension = 200;
// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
document.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
   var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
   if (st > lastScrollTop){
      // downscroll code
      console.log('down');
      if(dimension<= maxdimension)
      dimension =Math.floor(dimension+(window.scrollY/90))

      if(dimension >maxdimension)
        dimension = maxdimension
   } else {
      // upscroll code
      console.log('up');
      if(dimension> originaldimension)
      dimension =Math.floor(dimension-(window.scrollY/90))

      if(dimension < originaldimension)
        dimension = originaldimension
   }
   console.log(dimension);

   let prenobg = document.getElementById('preno')
    if(prenobg != null){
        
    prenobg.style.backgroundSize =  ""+dimension+"% "+dimension+"% "
    }

   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);

*/ 


//# sourceMappingURL=index.f382b954.js.map
